import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.css']
})
export class NotFoundComponent implements OnInit {

  logoAmarillo = 'assets/universidad-surcolombiana-multicampos-white.png';
  tituloAplicacion = 'Evaluación Docente Web';
  version = '3.0';
  fechaActual = new Date().getFullYear();

  constructor(private router: Router) { }

  ngOnInit() {
  }

  handleGoBack() {
    window.history.back();
  }

  handleGoHome() {
    this.router.navigate(['/']);
  }

}
